// extracted by mini-css-extract-plugin
module.exports = {"eyebrow":"Eyebrow_eyebrow__2iKD4"};